import * as types from '../mutation-types';

// state
export const state = {
    data: appDomainConfig
};

// getters
export const getters = {
    data: state => state.data
};

// mutations
export const mutations = {
    [types.FETCH_CONFIG](state, data) {
        state.data = data;
    }
};

// actions
export const actions = {};